import { Box, Button, styled } from '@mui/material';
import { Grid } from '@mui/system';

const Container = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  fontSize: '0.875rem',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

const DateRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

const SpacedContainer = styled(Grid)({ padding: '0.5rem' });

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

const StatusRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  flex: 1,
});

const FooterBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '1.5rem',
  flexShrink: 0,
  justifyContent: 'space-between',
});

const RoleBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: 'fit-content',
});

const AvatarRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  marginTop: '0.25rem',
});

const OverlayContainer = styled(Box)({
  position: 'relative',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const BlurOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(4px)',
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  zIndex: 10,
}));

const CreateModelSupportButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(1),
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const BlurredContent = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasModelSupport' && prop !== 'readOnly',
})<{ hasModelSupport?: boolean; readOnly?: boolean }>(({ hasModelSupport, readOnly }) => ({
  filter: hasModelSupport === false && !readOnly ? 'blur(2px)' : 'none',
  pointerEvents: hasModelSupport === false && !readOnly ? 'none' : 'auto',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

export {
  AvatarRow,
  Container,
  DateRow,
  FooterBox,
  RoleBox,
  SpacedContainer,
  StatusRow,
  Wrapper,
  OverlayContainer,
  BlurOverlay,
  CreateModelSupportButton,
  BlurredContent
};
